import * as React from 'react';
import { memo } from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgResidential = function SvgResidential(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.97 62.592c-.099.73-.543 1.2-1.335 1.408H1.365C.672 63.896.227 63.426.03 62.592c.099-.73.544-1.148 1.335-1.252h6.23V31.922h-6.23c-.594 0-1.039-.313-1.335-.94-.1-.52.05-.99.445-1.407L37.258.156a1.836 1.836 0 0 1 1.484 0l14.387 11.58V6.572c.099-.73.544-1.2 1.335-1.408H64.55c.692.104 1.137.574 1.335 1.408v15.179l9.64 7.824c.396.313.544.782.445 1.408-.296.626-.741.939-1.335.939h-6.23V61.34h6.23c.693.104 1.138.521 1.335 1.252ZM38 2.817 5.072 29.262h65.855L38 2.817Zm25.361 16.9-7.713-5.947V7.824h7.713v11.892ZM10.115 61.34h5.043V57.27c.1-.626.544-1.043 1.335-1.252h1.187V38.65c.099-.73.544-1.2 1.335-1.408H29.1c.693.104 1.137.574 1.335 1.408v17.37h1.187c.692.104 1.137.521 1.335 1.251v4.069h32.927V31.922H10.115V61.34Zm49.392-10.797c.79-.209 1.236-.626 1.335-1.252v-10.64c-.198-.835-.643-1.305-1.335-1.409H39.335c-.791.209-1.236.678-1.335 1.408v10.641c.198.73.643 1.148 1.335 1.252h20.172ZM20.352 56.02h7.564V39.902h-7.564V56.02Zm37.968-8.137H40.522v-7.98H58.32v7.98ZM17.68 61.34h12.755v-2.66H17.68v2.66Z",
    fill: "#0C1733"
  })));
};

var Memo = /*#__PURE__*/memo(SvgResidential);

export { Memo as default };
//# sourceMappingURL=residential.svg.js.map
